import { useState } from "react"
import axiosInstance from "../../../../services/axios-client"
import { toast } from "react-toastify"
import { handleApiErrorWithLogs } from "../../../../utils/errorHandler"

const useRatingQuota = () => {
    const [file, setSelectedFile] = useState(null)
    const [logs, setLogs] = useState(null)
    const [loadingPagestate, setLoadingPage] = useState(false)

    const handleFileChange = (event) => {
        const file = event.target.files[0]
        setSelectedFile(file)
        setLogs(null) // Clear previous logs
    }

    const postRatingQuota = async (projectID, onSuccess) => {
        try {
            setLoadingPage(true)
            const formData = new FormData()
            formData.append("projectID", projectID)
            formData.append("excelFile", file)

            await axiosInstance.post('/auth/rating-quotas/upload', formData)
            toast.success("Success Add Rating Quota Projects")
            if (onSuccess) {
                onSuccess()
            }
            setSelectedFile(null)
        } catch (error) {
            handleApiErrorWithLogs(error, setLogs)
        } finally {
            setLoadingPage(false)
        }
    }

    return {
        file,
        handleFileChange,
        postRatingQuota,
        logs,
        loadingPagestate
    }
}

export default useRatingQuota